import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, RefreshCw, CloudUpload } from 'lucide-react';
import { useT } from '../context/LanguageContext';
import { toast } from 'sonner';

// Sync-status indicator — alleen zichtbaar in de desktop (Electron) app.
// Toont: online / offline (+ aantal wijzigingen in wachtrij) / bezig met synchroniseren.
export const SyncStatusBadge = () => {
  const { t } = useT();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!window.electron?.isElectron) return;
    window.electron.getSyncStatus?.().then(s => s && setStatus(s)).catch(() => {});
    window.electron.onSyncStatus?.((s) => setStatus(s));
    window.electron.onSyncErrors?.((errors) => {
      errors.forEach(e => toast.error(t('Synchronisatie mislukt voor', 'Synchronisatie mislukt voor') + ` ${e.method} ${e.path}`, { description: e.detail }));
    });
  }, [t]);

  if (!window.electron?.isElectron || !status) return null;

  let icon, label, bg;
  if (status.replaying) {
    icon = <RefreshCw size={13} className="sync-spin" />;
    label = `${t('Synchroniseren...', 'Synchroniseren...')} (${status.pending})`;
    bg = '#2563eb';
  } else if (!status.online) {
    icon = <WifiOff size={13} />;
    label = status.pending > 0
      ? `${t('Offline', 'Offline')} · ${status.pending} ${t('in wachtrij', 'in wachtrij')}`
      : t('Offline - wijzigingen worden lokaal bewaard', 'Offline - wijzigingen worden lokaal bewaard');
    bg = '#d97706';
  } else if (status.pending > 0) {
    icon = <CloudUpload size={13} />;
    label = `${status.pending} ${t('wijzigingen wachten op sync', 'wijzigingen wachten op sync')}`;
    bg = '#2563eb';
  } else {
    icon = <Wifi size={13} />;
    label = t('Online', 'Online');
    bg = '#16a34a';
  }

  return (
    <div data-testid="sync-status-badge" style={{
      position: 'fixed', bottom: 14, left: 14, zIndex: 300,
      display: 'flex', alignItems: 'center', gap: 6,
      background: bg, color: '#fff', borderRadius: 999,
      padding: '5px 12px', fontSize: 12, fontWeight: 600,
      boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
      transition: 'background-color 0.3s ease',
    }}>
      {icon}{label}
      <style>{`.sync-spin { animation: syncspin 1s linear infinite; } @keyframes syncspin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};
